__turbopack_context__.v({
  "aliases": "drug-quick-view-module__71UTuq__aliases",
  "backdrop": "drug-quick-view-module__71UTuq__backdrop",
  "badge": "drug-quick-view-module__71UTuq__badge",
  "badgeExtra": "drug-quick-view-module__71UTuq__badgeExtra",
  "badgeLabel": "drug-quick-view-module__71UTuq__badgeLabel",
  "badgeRow": "drug-quick-view-module__71UTuq__badgeRow",
  "badgeSource": "drug-quick-view-module__71UTuq__badgeSource",
  "badgeValue": "drug-quick-view-module__71UTuq__badgeValue",
  "badgeValueMuted": "drug-quick-view-module__71UTuq__badgeValueMuted",
  "badgeValueOnly": "drug-quick-view-module__71UTuq__badgeValueOnly",
  "caveat": "drug-quick-view-module__71UTuq__caveat",
  "chip": "drug-quick-view-module__71UTuq__chip",
  "chipWrap": "drug-quick-view-module__71UTuq__chipWrap",
  "close": "drug-quick-view-module__71UTuq__close",
  "condCount": "drug-quick-view-module__71UTuq__condCount",
  "condName": "drug-quick-view-module__71UTuq__condName",
  "condRow": "drug-quick-view-module__71UTuq__condRow",
  "conditions": "drug-quick-view-module__71UTuq__conditions",
  "emptyRow": "drug-quick-view-module__71UTuq__emptyRow",
  "error": "drug-quick-view-module__71UTuq__error",
  "follow": "drug-quick-view-module__71UTuq__follow",
  "followBody": "drug-quick-view-module__71UTuq__followBody",
  "followHeading": "drug-quick-view-module__71UTuq__followHeading",
  "head": "drug-quick-view-module__71UTuq__head",
  "headTitle": "drug-quick-view-module__71UTuq__headTitle",
  "heading": "drug-quick-view-module__71UTuq__heading",
  "identity": "drug-quick-view-module__71UTuq__identity",
  "identityPanel": "drug-quick-view-module__71UTuq__identityPanel",
  "identityText": "drug-quick-view-module__71UTuq__identityText",
  "lineClass": "drug-quick-view-module__71UTuq__lineClass",
  "lineHolder": "drug-quick-view-module__71UTuq__lineHolder",
  "lineIds": "drug-quick-view-module__71UTuq__lineIds",
  "lineTarget": "drug-quick-view-module__71UTuq__lineTarget",
  "more": "drug-quick-view-module__71UTuq__more",
  "name": "drug-quick-view-module__71UTuq__name",
  "orb": "drug-quick-view-module__71UTuq__orb",
  "overlay": "drug-quick-view-module__71UTuq__overlay",
  "panel": "drug-quick-view-module__71UTuq__panel",
  "quickPulse": "drug-quick-view-module__71UTuq__quickPulse",
  "section": "drug-quick-view-module__71UTuq__section",
  "sectionHead": "drug-quick-view-module__71UTuq__sectionHead",
  "skelBar": "drug-quick-view-module__71UTuq__skelBar",
  "statCell": "drug-quick-view-module__71UTuq__statCell",
  "statLabel": "drug-quick-view-module__71UTuq__statLabel",
  "statTrio": "drug-quick-view-module__71UTuq__statTrio",
  "statValue": "drug-quick-view-module__71UTuq__statValue",
  "statValueNone": "drug-quick-view-module__71UTuq__statValueNone",
  "tracking": "drug-quick-view-module__71UTuq__tracking",
});
